import React from 'react';
import { useTranslation } from 'react-i18next';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import Table from 'components/v2/Table';
import Button from 'components/v2/buttons/Button';
import CargomaticModal from 'components/v2/modal';

function AccessorialDetailsBody(accessorial) {
  const { t } = useTranslation();
  const columns = [
    {
      field: 'value',
      label: t('REQUIRED_DOCUMENTS'),
      render: (value, row) => {
        return t(value?.toUpperCase());
      },
    },
  ];

  if (!accessorial) {
    return null;
  }
  return (
    <div>
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="mb-4">
          <DescriptionListItem
            labelClassName="block text-sm font-medium text-gray-700 font-semibold"
            label={t('ACCESSORIAL')}
          >
            {t(accessorial?.accessorial?.toUpperCase())}
          </DescriptionListItem>
        </div>
        <div className="mb-4">
          <DescriptionListItem
            labelClassName="block text-sm font-medium text-gray-700 font-semibold"
            label={t('CUSTOMER_APPROVAL_REQUIRED_QUESTION')}
          >
            {accessorial.customer_approval_required && <span>{t('YES')}</span>}
            {!accessorial.customer_approval_required && <span>{t('NO')}</span>}
          </DescriptionListItem>
        </div>
        <div className="col-span-full">
          <Table
            columns={columns}
            data={accessorial?.rules}
            headers={columns}
            className="overflow-hidden shadow ring-1 ring-gray-200 sm:rounded-lg"
            trClassName="border rounded-sm"
          />
        </div>
      </div>
    </div>
  );
}

function AccessorialDetailsFooter(onHide) {
  const { t } = useTranslation();

  return (
    <div>
      <Button type="button" onClick={onHide}>
        {t('CLOSE')}
      </Button>
    </div>
  );
}

export default function AccessorialDetails({ accessorial, onHide, viewMode }) {
  const { t } = useTranslation();

  return (
    <CargomaticModal
      title={t('VIEW_ACCESSORIAL')}
      titleClassNames="text-lg font-medium leading-6 text-gray-700"
      show={!!accessorial && viewMode}
      onHide={onHide}
      body={AccessorialDetailsBody(accessorial)}
      footer={AccessorialDetailsFooter(onHide)}
    />
  );
}
